<template>
  <v-col class="align-self-center">
    <v-row class="justify-center text-center">
      <v-progress-circular
        :size="70"
        color="#055289"
        indeterminate
      />
    </v-row>

    <v-row
      v-if="displayMessage"
      class="caption justify-center pt-3"
    >
      <span>
        {{ displayMessage }}
      </span>
    </v-row>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters } = createNamespacedHelpers('messages')

export default {
  name: 'LoadingMessage',
  props: {
    message: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    ...mapGetters(['currentMessage']),

    messageFromStore() {
      return this.currentMessage ? this.currentMessage.text : ''
    },

    displayMessage() {
      return this.message || this.messageFromStore
    },
  },
}
</script>
